import request from '@/utils/request'

// 账号密码登录
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

// 发送短信验证码
export function sendSmsCode(data) {
  return request({
    url: '/auth/sms/send',
    method: 'post',
    data
  })
}

// 短信验证码登录
export function smsLogin(data) {
  return request({
    url: '/auth/sms/login',
    method: 'post',
    data
  })
}

// 发送注册验证码
export function sendRegisterCode(phone) {
  return request({
    url: '/auth/register/send-code',
    method: 'post',
    params: { phone }
  })
}

// 供应商注册
export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

// 发送找回密码验证码
export function sendResetCode(phone, userType) {
  return request({
    url: '/auth/reset/send-code',
    method: 'post',
    params: { phone, userType }
  })
}

// 重置密码
export function resetPassword(data) {
  return request({
    url: '/auth/reset',
    method: 'post',
    params: data
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/auth/change-password',
    method: 'post',
    data
  })
}
